import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of, Subject } from 'rxjs';
import { map, shareReplay, switchMap, take } from 'rxjs/operators';
import { StatusTotals } from '../model/validation';
import { HOSTNAME } from '../../util/hostname';
import { AuthService, UserSession } from '../../auth/services/auth.service';
interface ValidationSummary {
  id: string;
  createdDate: Date;
  uniqueId: string;
  status: string;
  key: string;
}

const API_ROOT = 'https://api.' + HOSTNAME + '/';
@Injectable({
  providedIn: 'root',
})
export class ValidationService {
  private filterValueSubject = new BehaviorSubject<any>(null);
  private filterValue$: Observable<string> = this.filterValueSubject;
  private csvDownloadSubject = new Subject<string | any>();
  public csvDownloadObservable$: Observable<string | any> = this
    .csvDownloadSubject;
  private statusTotalsSubject = new Subject<StatusTotals>();
  public statusTotalsObservable$: Observable<StatusTotals> = this
    .statusTotalsSubject;
  private session: UserSession;

  constructor(
    private httpClient: HttpClient,
    private authService: AuthService,
    private handler: HttpBackend
  ) {
    authService.onUserSession.subscribe((session: UserSession) => {
      this.session = session;
    });
  }

  getAllSummaryRules(): Observable<ValidationSummary[]> {
    return this.httpClient.get<ValidationSummary[]>(
      API_ROOT + 'validate',
      this.getOptions()
    );
  }
  getValidationResultsForCsv(validationKeys): Observable<[]> {
    return this.httpClient
    .get<[]>(API_ROOT + 'validate/csv/' + validationKeys?.from + '/' + validationKeys?.to, this.getOptions())
    .pipe(map((result) =>  result));
  }
  getRuleByKey<T>(summary: ValidationSummary): Observable<T> {
    const s3Key = summary.key;
    return this.httpClient
      .get<T>(API_ROOT + 'validate/' + s3Key, this.getOptions())
      .pipe(map((result) => Object.assign({ ...summary }, result)));
  }

  setFilterValueSubject(terms: object): void {
    this.filterValueSubject.next(terms);
  }

  listenForFilterValue(): Observable<string> {
    return this.filterValue$;
  }

  setDownloadCsvSubject(value: string | any): void {
    this.csvDownloadSubject.next(value);
  }

  setStatusTotalsSubject(value: StatusTotals): void {
    this.statusTotalsSubject.next(value);
  }

  get<T>(): Observable<T> {
    return this.httpClient.get<T>(API_ROOT + 'validate', this.getOptions());
  }

  postValidate(payload): Observable<any> {
    this.httpClient = new HttpClient(this.handler);
    return this.httpClient
      .post<any>(
        API_ROOT + 'validate/' + payload.reference,
        payload,
        this.getOptions()
      )
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  private getOptions() {
    return {
      headers: {
        Authorization: 'Bearer ' + this.session?.accessToken?.jwtToken,
        ID_TOKEN: this.session?.idToken?.jwtToken,
        Accept: 'application/json',
      },
    };
  }
}
